// extracted by mini-css-extract-plugin
export default {"modal":"MenuModal_modal__-8VSX","content":"MenuModal_content__thPLn","title":"MenuModal_title__ZzHqJ","close":"MenuModal_close__kC3nX","nav":"MenuModal_nav__1F8av"};